module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0073.jpg?v=735a788f";